/** Bejelentkezési token — süti (OAuth finish) + localStorage. */

export const AUTH_TOKEN_KEY = "autopark_token";

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const m = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

function writeCookie(name, value, maxAgeSec) {
  if (typeof document === "undefined") return;
  const secure = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAgeSec}${secure}; SameSite=Lax`;
}

function clearCookie(name) {
  if (typeof document === "undefined") return;
  const secure = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=; Path=/; Max-Age=0${secure}; SameSite=Lax`;
}

/** OAuth finish süti elsőbbséget kap — régi localStorage token ne írja felül az újat. */
export function getAuthToken() {
  const fromCookie = readCookie(AUTH_TOKEN_KEY);
  if (fromCookie) return fromCookie;
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAuthToken(token) {
  try {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  } catch {
    /* Safari privát / quota */
  }
  writeCookie(AUTH_TOKEN_KEY, token, 7 * 24 * 3600);
}

export function removeAuthToken() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch {
    /* ignore */
  }
  clearCookie(AUTH_TOKEN_KEY);
}

/** Csak érvénytelen session — ne töröljünk hálózati / átmeneti API hibánál. */
export function isAuthSessionInvalidError(error) {
  const status = error?.response?.status;
  return status === 401 || status === 403;
}
